import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NavigationImportsEffects } from './+state/navigation-imports.effects';
import { initialStateNavigation } from './+state/navigation-imports.init';
import { localStorageSyncReducer } from './+state/navigation-imports.metareducer';
import * as fromNavigationImports from './+state/navigation-imports.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromNavigationImports.NAVIGATION_IMPORTS_FEATURE_KEY, fromNavigationImports.navigationCtlReducer, {
      metaReducers: [localStorageSyncReducer],
      initialState: initialStateNavigation
    }),
    EffectsModule.forFeature([NavigationImportsEffects])
  ]
})
export class DataAccessNavigationImportsModule {}
